import type { QueryClient } from "@tanstack/react-query";

import { useToysStore } from "@storage/global/useToysStore";
import { toysAvailabilityStorage } from "@storage/sessionStorage";

import { QUERY_KEYS } from "@configs/api";

export const resetToysSession = (queryClient: QueryClient) => {
	toysAvailabilityStorage.removeItem();
	useToysStore.getState().resetToysSession();

	/**
	 * Removing these queries also cancels their in-flight requests without refetching.
	 * In might show canceled request in network tab.
	 */
	for (const queryKey of [QUERY_KEYS.TOYS_SESSION_TOKEN, QUERY_KEYS.TOYS_SESSION, QUERY_KEYS.TOYS_CAPABILITIES]) {
		queryClient.removeQueries({ queryKey: [queryKey] });
	}
};
